// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FinancesPageSharedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FinancesPageSharedQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, currentInternalUser?: { __typename?: 'InternalUser', id: string } | null | undefined, tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }>, enumDetails: { __typename?: 'AllEnumDetails', billStatus: Array<{ __typename?: 'BillStatusDetail', code: Types.BillStatus, name: string }>, billReviewReason: Array<{ __typename?: 'BillReviewReasonDetail', code: Types.BillReviewReason, name: string }>, billSource: Array<{ __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }> }, customerOwnerEntities: Array<{ __typename?: 'CustomerOwnerEntity', id: string, name: string }> };


export const FinancesPageSharedDocument = gql`
    query FinancesPageShared {
  internalUsers {
    id
    name
  }
  markets {
    id
    name
  }
  projects {
    id
    name
  }
  currentInternalUser {
    id
  }
  tradePartners {
    id
    name
  }
  enumDetails {
    billStatus {
      code
      name
    }
    billReviewReason {
      code
      name
    }
    billSource {
      code
      name
    }
  }
  customerOwnerEntities(filter: {}) {
    id
    name
  }
}
    `;

/**
 * __useFinancesPageSharedQuery__
 *
 * To run a query within a React component, call `useFinancesPageSharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancesPageSharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancesPageSharedQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinancesPageSharedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>(FinancesPageSharedDocument, options);
      }
export function useFinancesPageSharedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>(FinancesPageSharedDocument, options);
        }
// @ts-ignore
export function useFinancesPageSharedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>;
export function useFinancesPageSharedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinancesPageSharedQuery | undefined, FinancesPageSharedQueryVariables>;
export function useFinancesPageSharedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>(FinancesPageSharedDocument, options);
        }
export type FinancesPageSharedQueryHookResult = ReturnType<typeof useFinancesPageSharedQuery>;
export type FinancesPageSharedLazyQueryHookResult = ReturnType<typeof useFinancesPageSharedLazyQuery>;
export type FinancesPageSharedSuspenseQueryHookResult = ReturnType<typeof useFinancesPageSharedSuspenseQuery>;
export type FinancesPageSharedQueryResult = Apollo.QueryResult<FinancesPageSharedQuery, FinancesPageSharedQueryVariables>;